/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {McpCreditAlertSettings} from '../models/McpCreditAlertSettings';
import type {McpSaveCreditAlertSettingsRequest} from '../models/McpSaveCreditAlertSettingsRequest';

export interface GetMcpCreditAlertSettings$Request {
    accountId: number;
}

export interface GetMcpCreditAlertSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMcpCreditAlertSettingsRequest = createAction<PayloadData<void, GetMcpCreditAlertSettings$Request>>('MCP_ALERT_SETTINGS__GET_MCP_CREDIT_ALERT_SETTINGS__REQUEST');
export const getMcpCreditAlertSettingsSuccess = createAction<PayloadData<McpCreditAlertSettings, GetMcpCreditAlertSettings$Request>>('MCP_ALERT_SETTINGS__GET_MCP_CREDIT_ALERT_SETTINGS__SUCCESS');
export const getMcpCreditAlertSettingsFailure = createAction<PayloadData<Error, GetMcpCreditAlertSettings$Request, true>>('MCP_ALERT_SETTINGS__GET_MCP_CREDIT_ALERT_SETTINGS__FAILURE');

export const getMcpCreditAlertSettingsActions = [
    getMcpCreditAlertSettingsRequest,
    getMcpCreditAlertSettingsSuccess,
    getMcpCreditAlertSettingsFailure
] as const;

/**
 * Get credit alert settings for an account
 * @param {number} meta.accountId Id of account
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMcpCreditAlertSettings = (meta: GetMcpCreditAlertSettings$Request, config?: GetMcpCreditAlertSettings$Config) => {
    return {
        CALL_API: {
            types: getMcpCreditAlertSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/alerts/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveMcpCreditAlertSettings$Request {
    accountId: number;
    mcpSaveCreditAlertSettingsRequest: McpSaveCreditAlertSettingsRequest;
}

export interface SaveMcpCreditAlertSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveMcpCreditAlertSettingsRequest = createAction<PayloadData<void, SaveMcpCreditAlertSettings$Request>>('MCP_ALERT_SETTINGS__SAVE_MCP_CREDIT_ALERT_SETTINGS__REQUEST');
export const saveMcpCreditAlertSettingsSuccess = createAction<PayloadData<void, SaveMcpCreditAlertSettings$Request>>('MCP_ALERT_SETTINGS__SAVE_MCP_CREDIT_ALERT_SETTINGS__SUCCESS');
export const saveMcpCreditAlertSettingsFailure = createAction<PayloadData<Error, SaveMcpCreditAlertSettings$Request, true>>('MCP_ALERT_SETTINGS__SAVE_MCP_CREDIT_ALERT_SETTINGS__FAILURE');

export const saveMcpCreditAlertSettingsActions = [
    saveMcpCreditAlertSettingsRequest,
    saveMcpCreditAlertSettingsSuccess,
    saveMcpCreditAlertSettingsFailure
] as const;

/**
 * Save credit alert settings for an account
 * @param {number} meta.accountId Id of account
 * @param {McpSaveCreditAlertSettingsRequest} meta.mcpSaveCreditAlertSettingsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveMcpCreditAlertSettings = (meta: SaveMcpCreditAlertSettings$Request, config?: SaveMcpCreditAlertSettings$Config) => {
    return {
        CALL_API: {
            types: saveMcpCreditAlertSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/mcp/alerts/settings`,
            TRANSPORT_REQUEST_BODY: meta.mcpSaveCreditAlertSettingsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

